import React from "react";
import "./GetMusicOnTencent.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnTencent = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Tencent Music distribution",
    "Music delivered to Chinese platforms",
    "Reach millions of listeners in China",
    "Track performance & royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Tencent Music Distribution | Reach Chinese Streaming Platforms | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music to Tencent Music platforms with FT Tunes. Reach QQ Music, Kugou Music, and Kuwo Music audiences across China."
        />

        <meta
          name="keywords"
          content="Tencent Music distribution, QQ Music distribution, Kugou Music, Kuwo Music, China music distribution, FT Tunes"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="tencent-page">

        {/* HERO */}
        <section className="tencent-hero">
          <Container>

            <img
              src="/Images/tencent-logo.png"
              alt="Tencent Music"
              className="tencent-logo"
            />

            <h1>Distribute Your Music on Tencent</h1>

            <p>
              Reach one of the world’s largest music markets by distributing
              your music to Tencent Music platforms including QQ Music,
              Kugou Music, and Kuwo Music.
            </p>

            <Button
              className="gradient-btn-tencent"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-tencent"></div>
        </section>


        {/* SHOWCASE */}
        <section className="tencent-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Access China's Largest Streaming Network</h2>

                <p>
                  Tencent Music Entertainment connects artists with hundreds
                  of millions of listeners across China. Expand your global
                  reach and grow your fanbase in Asia’s biggest music market.
                </p>

                <Button
                  className="outline-btn-tencent"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-tencent.png"
                  alt="Get Your Music On Tencent"
                  className="tencent-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="tencent-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-tencent">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="tencent-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Tencent Music
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-tencent">
                  <h5>Massive Audience</h5>
                  <p>Reach millions of Chinese listeners.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-tencent">
                  <h5>Top Platforms</h5>
                  <p>Available on QQ, Kugou & Kuwo Music.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-tencent">
                  <h5>Global Expansion</h5>
                  <p>Grow your fanbase across Asia.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-tencent">
                  <h5>Royalty Tracking</h5>
                  <p>Transparent performance insights.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="tencent-cta">
          <Container>

            <h2>Reach China’s Music Market Today</h2>

            <Button
              className="gradient-btn-tencent big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnTencent;